export default [
  "Anchovy - Engraulis encrasicolus",
  "Anglerfish - Lophiidae",
  "Atlantic salmon - Salmo salar",
  "Blue ling - Molva dypterygia",
  "Blue whiting - Micromesistius poutassou",
  "Bluefin tuna - Thunnus thynnus",
  "Boarfish - Caproidae",
  "Cod - Gadus morhua",
  "Dab - Limanda limanda",
  "Greenland halibut - Reinhardtius hippoglossoides",
  "Haddock - Melanogrammus aeglefinus",
  "Hake - Merluccius merluccius",
  "Herring - Clupea harengus",
  "Horse mackerel - Trachurus",
  "Lemon sole - Microstomus kitt",
  "Ling - Molva molva",
  "Mackerel - Scomber scombrus",
  "Megrims - Lepidorhombus",
  "Northern prawn - Pandalus borealis",
  "Norway lobster - Nephrops norvegicus",
  "Norway pout - Trisopterus esmarkii",
  "Plaice - Pleuronectes platessa",
  "Pollack - Pollachius pollachius",
  "Porbeagle - Lamna nasus",
  "Redfish - Sebastes",
  "Roundnose granadier - Coryphaenoides rupestris",
  "Saithe - Pollachius virens",
  "Sandeel - Ammodytes",
  "Skates and rays - Rajiformes",
  "Sole - Solea solea",
  "Spiny dogfish - Squalus acanthias",
  "Sprat - Sprattus sprattus",
  "Swordfish - Xiphias gladius",
  "Turbot - Psetta maxima",
  "Tusk - Brosme brosme",
  "Whiting - Merlangius merlangus"
]



/** WEBPACK FOOTER **
 ** ./src/lib/fishes.js
 **/